import * as React from 'react';
import { Map, TileLayer, Polyline, Marker } from 'react-leaflet';
import * as L from 'leaflet';

interface MapInfoProps {
  order: models.Order;
}

class MapInfo extends React.Component<MapInfoProps, {}> {

  private bounds: L.LatLngBoundsLiteral;

  render() {

    let styles = {
      host: {
        flex: '1 1 100%',
        display: 'flex',
        position: 'relative' as 'relative'
      },
      map: {
        flex: '1 1 100%'
      }
    };

    let Leaflet: any = L; // tslint:disable-line
    const polyline = this.props.order.route.polyline ? 
      Leaflet.PolylineUtil.decode(this.props.order.route.polyline) : [];
    const position = { lat: this.props.order.driver.latitude, lng: this.props.order.driver.longitude };
    const markers: models.Place[] = [];
    if (this.props.order.route.place1.latitude && this.props.order.route.place1.longitude) {
      markers.push(this.props.order.route.place1);
    }
    if (this.props.order.route.place2.latitude && this.props.order.route.place2.longitude) {
      markers.push(this.props.order.route.place2);
    }
    if (this.props.order.route.place3.latitude && this.props.order.route.place3.longitude) {
      markers.push(this.props.order.route.place3);
    }
    if (this.props.order.route.place4.latitude && this.props.order.route.place4.longitude) {
      markers.push(this.props.order.route.place4);
    }
    if (this.props.order.route.place5.latitude && this.props.order.route.place5.longitude) {
      markers.push(this.props.order.route.place5);
    }

    let bounds: L.LatLngBoundsLiteral| undefined =  undefined;
    if (!this.bounds) {
      bounds = markers.map(m => {
        let r: L.LatLngTuple = [m.latitude, m.longitude];
        return r;
      });
      if (polyline.length) {
        let minLat = polyline[0];
        let maxLat = polyline[0];
        let minLng = polyline[0];
        let maxLng = polyline[0];
  
        polyline.forEach((p: [number, number]) => {
  
          if (p[0] < minLat[0]) {
            minLat = p;
          }
          if (p[0] > maxLat[0]) {
            maxLat = p;
          }
          if (p[1] < minLng[1]) {
            minLng = p;
          }
          if (p[1] > maxLng[1]) {
            maxLng = p;
          }
        });
        bounds.push(minLat);
        bounds.push(maxLat);
        bounds.push(minLng);
        bounds.push(maxLng);
      }
      this.bounds = bounds;
    }

    const carIcon = L.icon({
      iconUrl: '/img/car.svg',
      iconSize: [33, 32]
    });

    return (
      <div style={styles.host}>
        <Map
          zoom={12}
          style={styles.map}
          bounds={bounds}
          boundsOptions={{ paddingTopLeft: [0, 50] }}
        >
          <TileLayer
            attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Polyline positions={polyline} weight={5} fillColor="white" />
          {markers.map((l, index) => {
            let letter = 'ABCDE'[index];
            let letterColor = '';
            if (index === 0) {
              letterColor = ' start';
            } else if (index === (markers.length - 1)) {
              letterColor = ' finish';
            }
            let icon: L.DivIcon = new L.DivIcon({
              className: 'marker-icon',
              html: '<div class="osm-mrk"><div class="mrk-desc"><div class="mrk-letter' + letterColor + '">' + letter +
                '<div class="romb"></div></div><div class="mrk-title">' + l.name + '</div></div><div class="mrk-point"></div></div>' // tslint:disable-line
            });
            return (<Marker key={index} position={{ lat: l.latitude, lng: l.longitude }} icon={icon} />);
          })}
          <Marker position={position} icon={carIcon} />
        </Map>
        {this.props.children}
      </div>
    );
  }
}

export default MapInfo;



// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/components/MapInfo.tsx